const isReactComponent = ({ type }) => {
  return typeof type === 'function' || typeof type === 'object';
};

export default isReactComponent;
